import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

function PrivateRoute() {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');

  // Verificar se usuário está autenticado
  const isAuthenticated = token && user;

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
}

export default PrivateRoute;
